var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.076,
    height: 15,
    viewBox: "0 0 15.076 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9388",
    "data-name": "Group 9388",
    transform: "translate(-3349.482 -2528.505)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2127",
    "data-name": "Path 2127",
    d: "M3349.483,2574.44q0-2.313,0-4.625a1.62,1.62,0,0,1,1.694-1.707q3.123,0,6.245,0a1.259,1.259,0,0,1,.206,0,.439.439,0,0,1,0,.873,1.813,1.813,0,0,1-.294.005h-6.1a.76.76,0,0,0-.873.858q0,4.6,0,9.191a.755.755,0,0,0,.847.854q4.61,0,9.22,0a.751.751,0,0,0,.836-.836q0-3.078,0-6.157c0-.079,0-.157,0-.236a.44.44,0,0,1,.879-.012c.006.068,0,.137,0,.206q0,3.093,0,6.186a1.624,1.624,0,0,1-1.729,1.731h-9.22a1.624,1.624,0,0,1-1.72-1.712Q3349.482,2576.752,3349.483,2574.44Z",
    transform: "translate(0 -37.272)",
    fill: "#003d60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2128",
    "data-name": "Path 2128",
    d: "M3445.9,2530.37a3.1,3.1,0,0,1-.4.727q-3.294,3.327-6.619,6.624a.928.928,0,0,1-.439.208c-.573.128-1.15.234-1.726.35-.552.111-.783-.123-.67-.678s.214-1.135.348-1.7a1.161,1.161,0,0,1,.276-.529q3.226-3.249,6.471-6.481a1.031,1.031,0,0,1,1.62,0,9.807,9.807,0,0,1,.742.756A4.6,4.6,0,0,1,3445.9,2530.37Zm-3.269.219a1.908,1.908,0,0,1-.184.25c-1.621,1.626-3.233,3.262-4.877,4.865-.475.463-.362,1.046-.569,1.612.334-.066.591-.136.852-.163a1.314,1.314,0,0,0,.82-.451c1.6-1.617,3.216-3.223,4.825-4.833.075-.075.146-.154.2-.214Zm.746-.661,1.025,1.032c.027-.026.07-.066.111-.107.484-.477.484-.477,0-.959C3443.933,2529.308,3443.933,2529.308,3443.381,2529.928Z",
    transform: "translate(-81.346 0)",
    fill: "#003d60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2129",
    "data-name": "Path 2129",
    d: "M3457.653,2562.574l1.07,1.065c-.057.061-.128.14-.2.214q-2.414,2.416-4.825,4.833a1.317,1.317,0,0,1-.82.451c-.261.027-.517.1-.852.163.207-.566.1-1.149.57-1.612,1.644-1.6,3.255-3.239,4.877-4.865A1.887,1.887,0,0,0,3457.653,2562.574Z",
    transform: "translate(-96.363 -31.985)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2130",
    "data-name": "Path 2130",
    d: "M3556.264,2544.57c.552-.62.552-.62,1.138-.034.482.482.482.482,0,.96-.041.041-.084.081-.111.106Z",
    transform: "translate(-194.229 -14.642)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.1dd1ebb2f54f91063f0beefaeeb83c2f.svg";
export { ForwardRef as ReactComponent };